import React from 'react'
import { useTranslation } from 'react-i18next';
import HeaderIcons from '../../shared/HeaderIcons';
import { HorizontalBar } from 'react-chartjs-2';

const PmrDivision = ({
    IconMult,
    IconExcl,
    IconSatis,
    IconNoAsg,
    isLoan,
    isIgr,
    chartData,
    options,
    mp
}) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className="title-components">{t('extended_report.PMR-Division')}</h3>
            <div className='division-composition-monitoring'>
                <div className='subtitle-composition'>
                    <p>{t('extended_report.composition_according_to_divisions')}</p>
                </div>

                <div className='indicators-composition'>
                    <HeaderIcons Icon={IconMult} text={`${t('one_pager_report.problems')}`} />
                    <HeaderIcons Icon={IconExcl} text={`${t('one_pager_report.alert')}`} />
                    <HeaderIcons Icon={IconSatis} text={`${t('one_pager_report.satisfactory')}`} />
                    <HeaderIcons Icon={IconNoAsg} text={`${t('extended_report.ext-not-assigned')}`} />
                </div>
            </div>

            {(isLoan | isIgr) ? (
                <div className="pmr-chart-grid">
                    <div className='last-cycle'>
                        <p>{t('extended_report.projects_participating_in_the_last_cycle')}</p>

                        <div>
                            <p>{t('extended_report.ext_number_of_divisions')}</p>
                            <h3>{mp.PmrDivisions.divisionCount}</h3>
                        </div>

                        <div>
                            <p>{t('extended_report.ext_number_of_projects')}</p>
                            <h3>{mp.PmrDivisions.projectCount}</h3>
                        </div>
                    </div>

                    <div className="pmr-chart">
                        <HorizontalBar data={chartData} options={options} />
                    </div>
                </div>
            ) : (
                <div className='na-content'>
                    <p>N/A</p>
                </div>
            )}
        </>
    )
}

export default PmrDivision